import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Role, RolesRequest, RolesResponse } from './types'
import {
  isAllElementsOfSearchTextNotExist,
  mapSearchText,
} from '../../../../libs/utils'

export const rolesListMounted = createEvent<RolesRequest>()

export const getRoles = fx<void, RolesResponse>({
  method: 'GET',
  url: `/role`,
})

export const $roles = restore<Role[]>(
  getRoles.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfRoles = restore(
  getRoles.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: rolesListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query: Record<string, string | number> = {
      limit,
      page,
    }

    if (orderBy) {
      query['order'] = orderDirection + orderBy
    }

    let newObj: Record<string, string | null> = {}
    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }
    query['where'] = JSON.stringify(newObj)

    return { query }
  },
  target: getRoles,
})
